export default __webpack_public_path__ + "static/media/netflix-logo.aa38bcd9.svg";